/** Vite `base` with no trailing slash, or "" when the app is served at the host root. */
export function connectBasePath(baseUrl = import.meta.env.BASE_URL || "/"): string {
  let base = baseUrl || "/";
  if (!base.startsWith("/")) base = `/${base}`;
  if (base.length > 1 && base.endsWith("/")) base = base.slice(0, -1);
  if (base === "/") return "";
  return base;
}

/** Browser path for a router path (`/login` → `/connect/login` on the apex build). */
export function withBase(path: string, base = connectBasePath()): string {
  if (!path.startsWith("/") || path.startsWith("//")) return path;
  if (!base) return path;
  if (path === base || path.startsWith(`${base}/`)) return path;
  return `${base}${path}`;
}

/** Strip the Vite base so route helpers keep seeing `/meetup/...`. */
export function stripBase(pathname: string, base = connectBasePath()): string {
  if (!base) return pathname || "/";
  if (pathname === base) return "/";
  if (pathname.startsWith(`${base}/`)) {
    const rest = pathname.slice(base.length);
    return rest.startsWith("/") ? rest : `/${rest}`;
  }
  return pathname || "/";
}
